// extracted by mini-css-extract-plugin
export default {"scrollDownAnimation":"Purchase_scrollDownAnimation__GMGYz","bounce":"Purchase_bounce__UMdmi"};